"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterApiPluginResponseOverride = void 0;
class TwitterApiPluginResponseOverride {
    constructor(value) {
        this.value = value;
    }
}
exports.TwitterApiPluginResponseOverride = TwitterApiPluginResponseOverride;
